import React from "react";

const SingleSelectDropDown = ({
  dataArr,
  handleChange,
  name,
  disabled = false,
  required = false,
  value = "",
  className = "",
  divClassName,
  handleClick,
}) => {
  return (
    <div className={`${divClassName ? divClassName : "form-group"}`}>
      <select
        className={`form-control ${className ? className : ""}`}
        name={name}
        id={name}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        value={value ? value : ""}
        onClick={handleClick ? () => handleClick() : undefined}
      >
        {dataArr?.map((obj, index) => {
          return (
            <option key={index} value={obj.value} disabled={obj.disabled}>
              {obj.text}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SingleSelectDropDown;
